import { Mail, Phone } from 'lucide-react';
import * as Tabs from '@radix-ui/react-tabs';
import { useLocation } from 'react-router-dom';
import { contactForms, isContactFormPage } from '../data/contactForms';
import ContactForm from './ContactForm';

function FooterInquiry() {
  const { pathname } = useLocation();
  if (isContactFormPage(pathname)) return null;

  return (
    <section className="footer-inquiry" aria-labelledby="footer-inquiry-heading">
      <div className="footer-inquiry-inner">
        <div className="footer-inquiry-copy">
          <span className="eyebrow">Talk to C+M</span>
          <h2 id="footer-inquiry-heading">Let's Talk About Your Project</h2>
          <p>Have a question about baling equipment, parts, or your material handling needs? Choose a request type and send our team the details.</p>
          <div className="footer-inquiry-links">
            <a href="tel:8002253796"><Phone size={18} />(800) 225-3796</a>
            <a href="mailto:sales@baling.com"><Mail size={18} />sales@baling.com</a>
          </div>
        </div>
        <Tabs.Root className="footer-inquiry-forms" defaultValue="general">
          <Tabs.List className="footer-form-tabs" aria-label="Choose a request type">
            {contactForms.map((form) => (
              <Tabs.Trigger className="footer-form-tab" key={form.key} value={form.key}>
                {form.label}
              </Tabs.Trigger>
            ))}
          </Tabs.List>
          {contactForms.map((form) => (
            <Tabs.Content className="footer-form-panel" key={form.key} value={form.key}>
              <ContactForm
                initialTab={form.key}
                heading={form.key === 'general' ? 'Send Us a Message' : undefined}
                eyebrow={form.key === 'general' ? 'Your contact details' : undefined}
                formId="footer-inquiry-form"
              />
            </Tabs.Content>
          ))}
        </Tabs.Root>
      </div>
    </section>
  );
}

export default FooterInquiry;
